var App = App || {};

App.MortgageRateTable = (function ($) {
    "use strict";

    function init() {
        var $rateTable = $('.table');

        $rateTable.find('a.schedule').on('click', function (e) {
            var $this = $(e.target);
            var $modal = $($this.data("bs-target"));

            e.preventDefault()

            $modal
                .find(".modal-body > iframe")
                .attr("src", $this.attr("href"));            
        });
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.MortgageRateTable.init();
});